import { Map } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as dcsActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';

export const initialState = Map({
  publication: Map(),
  dataPoints: Map(),
  map: Map()
});

// The publication belongs to a facility, so everything here is stale the moment the user
// switches facility or signs out.
function resetState () {
  return initialState;
}

export const dcsPublicationReducer = createTypedReducer(initialState, {
  [dcsActions.FETCH_DCS_PUBLICATION] (state) {
    return state.setIn(['publication', 'loading'], true);
  },
  [dcsActions.FETCH_DCS_PUBLICATION_SUCCESS] (state, action) {
    return state.set('publication', Map({ loading: false, data: action.publication }));
  },
  [dcsActions.FETCH_DCS_PUBLICATION_FAILED] (state) {
    return state.setIn(['publication', 'loading'], false);
  },

  [dcsActions.FETCH_DCS_DATA_POINTS] (state) {
    return state.setIn(['dataPoints', 'loading'], true);
  },
  // the API merges across the selected devices' factories, so this is one catalogue
  [dcsActions.FETCH_DCS_DATA_POINTS_SUCCESS] (state, action) {
    return state.set('dataPoints', Map({ loading: false, data: action.dataPoints || Map() }));
  },
  [dcsActions.FETCH_DCS_DATA_POINTS_FAILED] (state) {
    return state.setIn(['dataPoints', 'loading'], false);
  },

  [dcsActions.FETCH_DCS_MAP] (state) {
    return state.setIn(['map', 'loading'], true);
  },
  [dcsActions.FETCH_DCS_MAP_SUCCESS] (state, action) {
    return state.set('map', Map({ loading: false, data: action.map }));
  },
  [dcsActions.FETCH_DCS_MAP_FAILED] (state) {
    return state.setIn(['map', 'loading'], false);
  },

  [CHANGE_CLIENT]: resetState,
  [CLEAR]: resetState
});
